import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'safety',
  LABEL: 'Safety',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,97aee8ed-13da-4c34-b177-8669a86b697c',
  PAGES_LIST_ID: 'c5c0d556-5f60-46f5-bba5-694c6c90122d',
  DOCUMENTS_LIST_ID: '914155ab-fed5-4741-95f2-59b6c88b9db6',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuO3orpfaEzRMsXeGaahraXymZnQfx16ERqn-_XDFqPE2',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuO3orpfaEzRMsXeGaahraXyrVUGR1f5BR5XyWbbIi522',
  NEWS_TEMPLATE_ID: 'afb2be3c-def0-40b3-b8fb-d3873276c206',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  MANAGER_ROLES: [ROLES.QSE_SAFETY_MANAGER],
  VIVA_COMMUNITY_ID: 'eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMjIyNTIzNjc4NzIifQ'
}

export default config